import { createBackgroundLayersElement } from './renderNodes';
import { DND_GRID_AREA_BACKGROUND_CLASS_NAME } from './constants';
import { buildSectionClassname, buildContainerClassname } from './css/classNameUtils';
import { shouldUpdateBackgroundDom as shouldUpdate } from './shouldUpdateBackgroundDom';
export default function updateBackgroundDom(gridNode, breakpointMediaQueries) {
  if (!shouldUpdate(gridNode, breakpointMediaQueries)) {
    return;
  }
  const nodeId = gridNode.getId();
  const targetElement = document.querySelector(`.${gridNode.isSection() ? buildSectionClassname(nodeId) : buildContainerClassname(nodeId)}`);
  if (!targetElement) return;
  const shouldHaveBackground = hasAnyBackgroundLayers(gridNode.getValue().styles, breakpointMediaQueries);
  const existingBackgroundContainer = Array.from(targetElement.children).find(child => child.classList.contains(DND_GRID_AREA_BACKGROUND_CLASS_NAME));
  if (shouldHaveBackground && existingBackgroundContainer) {
    replaceBackgroundContainer(targetElement, existingBackgroundContainer, gridNode);
  } else if (shouldHaveBackground && !existingBackgroundContainer) {
    addBackgroundContainer(targetElement, gridNode);
  } else if (!shouldHaveBackground && existingBackgroundContainer) {
    removeBackgroundContainer(targetElement, existingBackgroundContainer);
  }
}
function hasAnyBackgroundLayers(styles, breakpointMediaQueries) {
  for (const [breakpoint, __] of breakpointMediaQueries) {
    if (!styles.breakpointStyles[breakpoint]) {
      return false;
    }
    if (styles.breakpointStyles[breakpoint].backgroundLayers && styles.breakpointStyles[breakpoint].backgroundLayers.length > 0) {
      return true;
    }
  }
  return false;
}
function replaceBackgroundContainer(targetElement, existingBackground, gridNode) {
  const newBackground = createBackgroundLayersElement(gridNode);
  targetElement.replaceChild(newBackground, existingBackground);
}
function addBackgroundContainer(targetElement, gridNode) {
  const newBackground = createBackgroundLayersElement(gridNode);
  targetElement.prepend(newBackground);
}
function removeBackgroundContainer(targetElement, existingBackground) {
  targetElement.removeChild(existingBackground);
}